import * as i0 from '@angular/core';
import { inject, Directive, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tuiTypedFromEvent } from '@taiga-ui/cdk/observables';
import { TUI_IS_IOS } from '@taiga-ui/cdk/tokens';
import { tuiInjectElement } from '@taiga-ui/cdk/utils/dom';
import { tap, map, switchMap, race, filter, take } from 'rxjs';
const STYLE = {
  transform: 'scale(0.95)',
  opacity: '0.6',
  background: 'rgba(146, 153, 162, 0.12)'
};
function tuiFindTouchIndex(touches, id) {
  for (let i = 0; i < touches.length; i++) {
    if (touches[i]?.identifier === id) {
      return i;
    }
  }
  return -1;
}
let TuiTouchable = /*#__PURE__*/(() => {
  class TuiTouchable {
    constructor() {
      this.isIOS = inject(TUI_IS_IOS);
      this.el = tuiInjectElement();
      this.tuiTouchable = '';
      if (!this.isIOS) {
        return;
      }
      tuiTypedFromEvent(this.el, 'touchstart', {
        passive: true
      }).pipe(tap(() => this.onTouchStart()), map(({
        touches
      }) => touches[touches.length - 1]?.identifier), switchMap(identifier => race(tuiTypedFromEvent(this.el, 'touchmove', {
        passive: true
      }).pipe(filter(({
        touches
      }) => this.hasTouchLeft(this.el, touches, identifier ?? 0))), tuiTypedFromEvent(this.el, 'touchend')).pipe(take(1))), takeUntilDestroyed()).subscribe(() => {
        this.el.style.removeProperty('transform');
        this.el.style.removeProperty('opacity');
        this.el.style.removeProperty('background');
      });
    }
    get style() {
      return this.tuiTouchable || 'transform';
    }
    hasTouchLeft(element, touches, identifier) {
      const {
        ownerDocument
      } = element;
      const id = tuiFindTouchIndex(touches, identifier);
      if (!ownerDocument || id === -1) {
        return true;
      }
      const {
        clientX = 0,
        clientY = 0
      } = touches[id] ?? {};
      return !element.contains(ownerDocument.elementFromPoint(clientX, clientY));
    }
    onTouchStart() {
      if (this.style !== 'transform') {
        this.el.style.removeProperty('transition');
      } else {
        this.el.style.setProperty('transition', 'transform 0.2s');
      }
      this.el.style.setProperty(this.style, STYLE[this.style]);
    }
    static {
      this.ɵfac = function TuiTouchable_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTouchable)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiTouchable,
        selectors: [["", "tuiTouchable", ""]],
        inputs: {
          tuiTouchable: "tuiTouchable"
        }
      });
    }
  }
  return TuiTouchable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTouchable, tuiFindTouchIndex };
